import React from "react";

import { AppListItem } from "Components/AppListItem";
import { MemberUser } from "Models/members/member.user";
import { useTranslation } from "react-i18next";

import { handleContentCounter, handleMemberContent } from ".";
import {
  MemberDetailsContainer,
  MemberDetailsRow,
  MemberDetailsWrapper,
  SectionTitle,
} from "./styles";

interface MemberUserDetailsProps {
  currentMember: MemberUser;
}
export const MemberUserDetails = ({ currentMember }: MemberUserDetailsProps) => {
  const { t: translate } = useTranslation();

  return (
    <>
      <div>
        <SectionTitle>{translate("userDetails")}</SectionTitle>
      </div>
      <MemberDetailsContainer>
        <MemberDetailsWrapper>
          <MemberDetailsRow>
            <AppListItem
              title={translate("username")}
              subtitle={currentMember.user?.username}
              verifyIfIsEmpty
              disableGutters
            />
            <AppListItem
              title={translate("mobile")}
              subtitle={currentMember.mobile}
              verifyIfIsEmpty
              disableGutters
            />
            <AppListItem
              title={translate("phone")}
              subtitle={currentMember.phone}
              verifyIfIsEmpty
              disableGutters
            />
          </MemberDetailsRow>
          <MemberDetailsRow>
            <AppListItem
              title={translate("typeOfUser")}
              subtitle={currentMember.typeOfMember}
              verifyIfIsEmpty
              disableGutters
            />
            <AppListItem
              title={translate("manager")}
              subtitle={currentMember.userCompany?.manager?.fullName}
              verifyIfIsEmpty
              disableGutters
            />
            <AppListItem
              title={translate("accessTo")}
              renderCounter
              contentCountValue={handleContentCounter(currentMember.userCompany?.applications)}
              // subtitle={handleMemberApplications(currentMember.userCompany?.applications)}
              subtitle={handleMemberContent(currentMember.userCompany?.applications || [], "name")}
              verifyIfIsEmpty
              disableGutters
            />
          </MemberDetailsRow>
        </MemberDetailsWrapper>
      </MemberDetailsContainer>
    </>
  );
};
